import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { UserProvider } from './auth/UserContext';
import { Layout } from './components/Layout';
import { ConsultantView } from './pages/ConsultantView';
import { TeamLeadView } from './pages/TeamLeadView';
import { DirectorView } from './pages/DirectorView';
import { CompanyView } from './pages/CompanyView';
import { SettingsView } from './pages/SettingsView';
import { HelpView } from './pages/HelpView';
import './styles/global.css';
import './styles/components.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <UserProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<ConsultantView />} />
              <Route path="/team" element={<TeamLeadView />} />
              <Route path="/territory" element={<DirectorView />} />
              <Route path="/company" element={<CompanyView />} />
              <Route path="/settings" element={<SettingsView />} />
              <Route path="/help" element={<HelpView />} />
            </Route>
          </Routes>
        </UserProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
